import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import st from './Pill.module.css';

export function Pill({ icon, children }) {
  return (
    <div className={st.pill}>
      <span className={st.icon} aria-hidden="true">
        <FontAwesomeIcon icon={icon} />
      </span>
      <span className={st.text}>{children}</span>
    </div>
  );
}

